import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 0,
  class: "time-out-flag"
}
const _hoisted_3 = {
  key: 1,
  class: "new-list-flag"
}
const _hoisted_4 = {
  key: 2,
  class: "black-list-flag"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 3 }

import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import { genderEnum, linkRoleTypeEnum, customerAllStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import CustomerAssign from '../components/customerAssign.vue'
import CustomerAllotRegion from '../components/customerAllotRegion.vue'
import { customerStageEnum } from '@/views/marketing/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { publicCustomerList, potentialDetail, publicCustomerCollect } from '@/api/gucangSales/customerCenter'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuPublicClueParams, FbuPublicClueListItem } from '@/typings/api/clueManage'

const __default__ = { name: 'DcCosFbuPublicCustomer' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

// 线索类型枚举列表
const stageEnum = computed(() => customerStageEnum.filter((item) => item.value !== 1))
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_follow_purpose: [], // 拜访目的
  fbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_purpose', 'fbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}

onMounted(() => {
  getByParamCodes()
})

// 获取详情联系人信息
const showMask = (record: FbuPublicClueListItem, callBack: (res: any) => void) => {
  potentialDetail(record.cosId).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}

const tableRef = ref()
const queryForm = reactive<FbuPublicClueParams>({ contact: { type: 1 } })

const detailUrl = (record: FbuPublicClueListItem) => {
  if (record.stage === 2) {
    return `/fbu/potential/view?cosId=${record.cosId}&isPublicClue=1`
  } else if (record.stage === 3) {
    return `/fbu/contract/view?cosId=${record.cosId}&isPublicClue=1`
  } else if (record.stage === 4) {
    return `/fbu/clients/view?cosId=${record.cosId}&isPublicClue=1`
  }
}

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'cosId', width: 200 },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '来源渠道', dataIndex: 'channel' },
  { title: '客户阶段', dataIndex: 'stage', dicData: customerStageEnum },
  { title: '客户状态', dataIndex: 'status', dicData: customerAllStatusEnum },
  { title: '历史最高客户阶段', dataIndex: 'turnedTransaction', width: 260 },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '最新跟进情况', dataIndex: 'followDesc' },
  { title: '子客户代码', dataIndex: 'arkCode' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '性别', dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: '角色', dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: '创建时间', dataIndex: 'createTime', width: 190 },
  { title: '上次领取时间', dataIndex: 'lastReceiveTime', width: 190 },
  { title: '流转公海池时间', dataIndex: 'transferTime', width: 190 },
  { title: '备注', dataIndex: 'remark' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])
const getList = (queryForm: FbuPublicClueParams, callBack: (res: any) => void) => {
  publicCustomerList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<FbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: FbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const customerAssignRef = ref()
const handleAssignPerson = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的客户')
  const data = row ? [row] : toRaw(selectedData.value)
  customerAssignRef.value?.init(data)
}

// 分配客户区域
const customerAllotRegionRef = ref()
const handleAllotRegion = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的客户')
  const data = row ? [row] : toRaw(selectedData.value)
  customerAllotRegionRef.value?.init(data)
}
// 领取客户
const handleReceive = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning('请选择需要领取的客户')
  }
  const cosIdList: any[] = []
  if (row) {
    cosIdList.push(row.cosId)
  } else {
    selectedData.value.forEach((item) => {
      cosIdList.push(item.cosId)
    })
  }
  AModal.confirm({
    title: '是否确认领取？',
    okText: '领取',
    onOk() {
      publicCustomerCollect({ cosIdList }).then(() => {
        message.success('领取成功')
        handleQueryChange('fetch')
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              rowKey: "cosId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[15] || (_cache[15] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              onMask: showMask,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosFbuPublicCustomer"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "客户阶段" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.stage,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.stage) = $event)),
                          options: stageEnum.value,
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                          valueModifiers: { trim: true },
                          maxlength: 100,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.channelList) = $event)),
                              appId: "cos_fbu",
                              paramCode: "fbu_source_channel",
                              style: {"width":"33%"}
                            }, null, 8, ["ids"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入",
                              allowClear: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          startTime: queryForm.createTimeStart,
                          "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.createTimeStart) = $event)),
                          endTime: queryForm.createTimeEnd,
                          "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.createTimeEnd) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "子客户代码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.arkCode,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.arkCode) = $event)),
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"},
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("固定电话")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("邮箱")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("微信号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("qq")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_fbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "前负责人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.prevSeller,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.prevSeller) = $event)),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.cosId,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.cosId) = $event)),
                          maxlength: 500,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("分配客户")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_public_customer_assign_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (handleReceive()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("领取客户")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_public_customer_receive_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (handleAllotRegion()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("分配区域")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_public_customer_assign_region_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_fbu",
                  taskType: "226",
                  search: queryForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'fbu_public_customer_export_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'customerName')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (record.timeoutFlag === true)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "超时"))
                        : _createCommentVNode("", true),
                      (record.haveFollowFlag === false)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "New"))
                        : _createCommentVNode("", true),
                      (record.blackListFlag)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "黑名单"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        to: detailUrl(record),
                        class: "ant-table-cell-ellipsis",
                        title: text
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text || '--'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'arkCode')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(Array.isArray(text) && text.length > 0 ? text.join('、') : '--'), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 2,
                      appId: "cos_fbu",
                      paramCode: "fbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'turnedTransaction')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(record.turnedTransaction ? `成交客户(${record.turnedTransaction})` : (record.turnedContract ? `签约客户(${record.turnedContract})` : (record.turnedPotential ? `潜在客户(${record.turnedPotential})` : '--'))), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 4,
                      appId: "cos_fbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleAssignPerson(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("分配客户")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_public_customer_assign_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleReceive(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("领取客户")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'fbu_public_customer_receive_btn']
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CustomerAssign, {
      ref_key: "customerAssignRef",
      ref: customerAssignRef,
      onFetch: _cache[16] || (_cache[16] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(CustomerAllotRegion, {
      ref_key: "customerAllotRegionRef",
      ref: customerAllotRegionRef,
      onFetch: _cache[17] || (_cache[17] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})